export const PRICE_BREAKDOWN = "Price breakdown";
export const ROOM = "Room";
export const NIGHT = "night";
export const TAXES_AND_FEES = "Taxes & fees";
export const PAID_AT_TIME_OF_BOOKING = "Paid at time of booking";
export const DUE_AT_HOTEL = "Due at hotel";
export const CANCEL_FOR_ANY_REASON = "Cancel for any reason";
export const ADDITIONAL_SERVICE_FEE =
  "Additional service fee (Due at check-in)";
export const TRIP_TOTAL = "Total";
